import { render, staticRenderFns } from "./LogoMainVersionSection.vue?vue&type=template&id=2ee1c152"
import script from "./LogoMainVersionSection.vue?vue&type=script&lang=ts"
export * from "./LogoMainVersionSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoMainVersionSection.vue?vue&type=style&index=0&id=2ee1c152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports